import {defineStore} from 'pinia'
import api from '@/services/api'
import {useUserStore} from '@/stores/user'

export const useNotificationsMenuStore = defineStore('notificationsMenu', {
    state: () => ({
        open: false,
        active: false,
        // Only get items from the last month.
        timeStamp: Math.floor(Date.now() / 1000) - (60 * 60 * 24 * 30),
        promise: null,
        items: []
    }),
    actions: {
        setPromise(promise) {
            if (this.promise) {
                clearInterval(this.promise)
            }
            this.promise = promise
        },
        openMenu() {
            this.open = true
            this.active = false
            
            this.setItems()
            
            const promise = setInterval(() => {
                this.setItems()
            }, 1000)
            
            this.setPromise(promise)
        },
        hideMenu() {
            this.open = false
            this.setPromise(null)
        },
        async setItems() {
            const userStore = useUserStore()
            
            if (!userStore.exists) {
                return
            }
            
            const obj = await api.get('api/notifications')
            
            this.active = this.items.length !== obj.data.items.length && !this.open
            
            this.items = obj.data.items
        },
        async removeItem({itemId}) {
            await api.patch(`api/component/notification/${itemId}`, {
                hidden: 1,
            })
        },
        clearActiveItems() {
        }
    }
})